import React from 'react';
import IconButton from './IconButton';
import classNames from '../../utility/classNames';

const BackForwardButtons = ({ prev, next, classes }) => {
  return (
    <div className="w-full flex flex-wrap justify-center space-y-4 gap-4 sm:space-y-0  sm:justify-between mt-4 px-2">
      {prev ? (
        <IconButton
          text={prev.name}
          handleClick={prev.back}
          style="primary-lg"
          icon="arrow-left"
          iconPosition="left"
          classes={classNames(classes, 'min-w-[14rem] whitespace-nowrap')}
        />
      ) : (
        // Render an empty element to keep the 'justify-between' style
        <span />
      )}
      {next ? (
        <IconButton
          text={next.name}
          handleClick={next.next}
          icon="arrow-right"
          style="primary-lg"
          classes={classNames(classes, 'min-w-[14rem] whitespace-nowrap')}
        />
      ) : (
        // Render an empty element to keep the 'justify-between' style
        <span />
      )}
    </div>
  );
};

export default BackForwardButtons;
